export default __webpack_public_path__ + "static/sea-easy-capital-logo-3bb5eadf481feb6e91976d5fb23f53c2.png";